import { Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { FinanceAreaService } from '../../../finance-area.service';
import { FinanceAwardsPageService } from '../../finance-awards.page.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'finance-awards-entrepreneur-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './finance-awards-entrepreneur-view.part.html',
})
export class FinanceAwardsEntrepreneurViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly financeAreaService = inject(FinanceAreaService);
	private readonly pageService = inject(FinanceAwardsPageService);

	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public acceleratorCourseAssignments = computed(() => {
		
		//const data = this.financeAreaService.experienceData()?.acceleratorCourseAssignments ?? [];

		// Add meeting display text using utility functions
		// return data.map(acc => {
		// 	const formattedData = this.util.date.formatAccMeetingSlot(
		// 		acc.meetingStartSlot,
		// 		acc.standardFourTimeZoneId,
		// 	);
		// 	return {
		// 		...acc,
		// 		meetingLocalDisplayText: formattedData.localDisplayTime,
		// 		meetingAcceleratorDisplayText: formattedData.acceleratorDisplayTime,
		// 	};
		// });

		return [];
	});

	async ngOnInit() {
		const a = 1;
		// await this.financeAreaService.loadExperienceData();
	}
}
